var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDock = function SvgDock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.333 3.333c0-.92-.746-1.666-1.666-1.666H8.332c-.92 0-1.667.746-1.667 1.666V5H3.333c-.92 0-1.667.746-1.667 1.667v10c0 .92.747 1.666 1.667 1.666h10c.92 0 1.667-.746 1.667-1.666V15h1.666c.921 0 1.667-.746 1.667-1.667v-10Zm-10 0h8.333v10H15V6.667C15 5.747 14.254 5 13.333 5h-5V3.333Zm-5 3.334v10h10v-10h-10Zm3.333 5.435V10A.833.833 0 1 0 5 10v4.167a.834.834 0 0 0 .833.833H10a.833.833 0 1 0 0-1.667H7.897l3.515-3.514a.87.87 0 0 0-1.231-1.23l-3.514 3.513Z"
  })));
};

export default SvgDock;